import Accounts from "./Accounts";


class Connection extends Accounts{
    constructor(params) {
      super(params);
      this.accountLabel = params.account.charAt(0).toUpperCase() + params.account.slice(1);
    this.accountType = params.account.charAt(0).toUpperCase() + params.account.slice(1);
    this.account = params.connection.account.charAt(0).toUpperCase() + params.connection.account.slice(1);
    this.isParent = true;
    this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }

    setAccountType(val){
        this.isParent = (this.accountType == "Smptrack") ? false : this.isParent;
        if (this.accountType == "Smptrack"){
          this.switch = true;
        }
    }

    setPlatformId(val){
      this.platformId = val;
    }
    setName(val){
      this.name = val;
    }
}

export default Connection;
  